import { useDispatch } from 'react-redux';
import { Form } from 'react-bootstrap';
import { IoCheckmarkCircle, IoAlertCircleOutline } from 'react-icons/io5';
import { setProducerVerification } from '../../../../store/actions/packagingUnit';

const formatDate = (value) => new Date(value).toLocaleString('sk-SK', { dateStyle: 'medium', timeStyle: 'short' });

const ProducerVerificationTab = ({ unit, description }) => {
    const dispatch = useDispatch();
    const summary = unit.producerVerificationSummary ?? { criteria: [], complete: true, requiredCount: 0, checkedCount: 0 };

    const toggle = (criterionId, checked) => {
        dispatch(setProducerVerification({ packagingUnitId: unit._id, criterionId, checked }));
    };

    return (
        <div>
            {description && (
                <p className="text-muted small mb-3" style={{ maxWidth: 720 }}>{description}</p>
            )}

            <div
                className="d-flex align-items-center gap-3 mb-4"
                style={{
                    backgroundColor: summary.complete ? '#E6F4EA' : '#FBEBD8',
                    border: `1px solid ${summary.complete ? '#8FCBA6' : '#C97D2C'}`,
                    borderRadius: 12,
                    padding: '14px 18px',
                }}
            >
                {summary.complete
                    ? <IoCheckmarkCircle size={28} style={{ color: '#198754', flexShrink: 0 }} />
                    : <IoAlertCircleOutline size={28} style={{ color: '#C97D2C', flexShrink: 0 }} />}
                <div>
                    <div style={{ fontSize: 15, fontWeight: 700, color: summary.complete ? '#198754' : '#C97D2C' }}>
                        Registrácia výrobcu: {summary.complete ? 'Potvrdená' : 'Nepotvrdená'}
                    </div>
                    <div className="text-muted" style={{ fontSize: 12.5 }}>
                        {summary.checkedCount}/{summary.requiredCount} bodov potvrdených
                    </div>
                </div>
            </div>

            {summary.criteria.map((c) => (
                <div
                    key={c.id}
                    className="d-flex align-items-start gap-3 p-3 mb-2"
                    style={{ border: '1px solid #EEF0F8', borderRadius: 12 }}
                >
                    <Form.Check
                        type="checkbox"
                        id={`producer-verification-${c.id}`}
                        checked={c.checked}
                        onChange={e => toggle(c.id, e.target.checked)}
                        style={{ marginTop: 2 }}
                    />
                    <div>
                        <label htmlFor={`producer-verification-${c.id}`} className="fw-semibold mb-0" style={{ fontSize: 13.5, color: '#0B1157', cursor: 'pointer' }}>
                            {c.title} <span className="text-muted fw-normal">({c.article})</span>
                        </label>
                        <div className="text-muted small mt-1" style={{ maxWidth: 620 }}>{c.description}</div>
                        {c.checked && (
                            <div className="text-muted mt-1" style={{ fontSize: 11.5 }}>
                                Potvrdené{c.checkedByName && ` · ${c.checkedByName}`}{c.checkedAt && ` · ${formatDate(c.checkedAt)}`}
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default ProducerVerificationTab;
